import { SubscriptionPeriod } from '@anm/api/modules/subscription';
import { UserSubscriptionDetails } from '@anm/api/modules/user';
import { ANNUAL, LIFETIME, MONTHLY } from '@anm/constants/subscription';

type IsSamePeriodProps = {
  view: SubscriptionPeriod;
  currentSubscription?: UserSubscriptionDetails;
};

export default ({ view, currentSubscription }: IsSamePeriodProps) => {
  if (!currentSubscription) return false;

  const isSamePeriod =
    currentSubscription.billingPeriod === LIFETIME ||
    (view === ANNUAL && currentSubscription.billingPeriod === ANNUAL) ||
    (view === MONTHLY && currentSubscription.billingPeriod === MONTHLY);

  return isSamePeriod;
};
